import type { Action } from 'redux';

export const CLEAR_COST_FILE_TEMPLATE = 'CLEAR_COST_FILE_TEMPLATE' as const;

export const clearCostFileTemplate = () => ({ type: CLEAR_COST_FILE_TEMPLATE });

export type ClearCostFileTemplateAction = Action<typeof CLEAR_COST_FILE_TEMPLATE>;
